module.exports = __webpack_public_path__ + "static/media/Acc-3a.e9ceb2c4.png";